module.exports = __webpack_public_path__ + "static/media/iconActivities.788cf62b.svg";